
const getList = state => state.list
const getAvailableAppointments = state => state.availableAppointments

export default {
  getList,
  getAvailableAppointments
}



// WEBPACK FOOTER //
// ./src/store/modules/proced/getters.js